import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
//import Button from '../components/Button'
import Button from '@material-ui/core/Button'
//import Typography from '../components/Typography'
import Typography from '@material-ui/core/Typography'
import Layout from './Layout'
import Markdown from '../ui/Markdown'
import Box from '@material-ui/core/Box'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import Fade from 'react-reveal/Fade';
import TitleContentBlock from '../contentblocks/TitleContentBlock'

//const backgroundImage =
//  'https://images.unsplash.com/photo-1534854638093-bada1813ca19?auto=format&fit=crop&w=1400&q=80'

const styles = theme => ({
  background: {
//    backgroundImage: `url(${backgroundImage})`,
//    backgroundColor: '#7fc7d9', // Average color of the background image.
    backgroundPosition: 'center',
  },
  imageSide: {
    width: '100%',
  },
  imageCenter: {
    width: '100%',
//    [theme.breakpoints.up('sm')]: {
//      width: '50%',
//    },

//    [theme.breakpoints.down('sm')]: {    
//      marginLeft: theme.spacing(-2),
//      width: 'calc(100% + 32px)'
//    }
  },
  button: {
    minWidth: 200,
  },
  h5: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(10),
    },
  },
  more: {
    marginTop: theme.spacing(2),
  },
  imageDiv: {
    width: '54%'
  },
  spacingDiv: {
    width: '6%'
  },
  contentDiv: {
    width: '40%',
  }
});

const Section = (props) => {
  const { theme, classes, key, sectionIndex, openLink, createContentBlock, children } = props

  // Section attributes
  const { color, section_height, content_width, vertical_alignment, horizontal_alignment, section_width, overlay_opacity, background_images, item_spacing } = props

  // Default section content. Will be send to TitleContentBlock

  let smUp = useMediaQuery(theme.breakpoints.up('sm'))

  let textColor
  if(color === 'dark'){
    textColor =  theme.sectionPalette.dark.contrastText
  }else if(color === 'accent'){
    textColor =  theme.sectionPalette.accent.contrastText
  }else if(color === 'light'){
    textColor =  theme.sectionPalette.light.contrastText
  }else if(color === 'white'){
    textColor =  theme.sectionPalette.white.contrastText
  }else{
    textColor =  theme.sectionPalette.black.contrastText
  }
  
  const contentData = {
    title: props.title,
    subtitle: props.subtitle,
    body: props.body,
    images: props.images,
    link_to: props.link_to,
    button_title: props.button_title,
    button_style: props.button_style,
    text_alignment: props.text_alignment,
    animation: props.animation,
    image_position: props.image_position,
    image_width: props.image_width,
    colorType: props.color || 'white',
    color: textColor,
    item_spacing: item_spacing,
  }

  let containerStyle = { 'display': 'flex' }
  if (horizontal_alignment && horizontal_alignment == 'left')
    containerStyle['justifyContent'] = 'flex-start'
  else if (horizontal_alignment && horizontal_alignment == 'right')
    containerStyle['justifyContent'] = 'flex-end'
  else
    containerStyle['justifyContent'] = 'center'

  if (!smUp) {
    // Add left/right padding
    containerStyle['paddingLeft'] = theme.spacing(2)
    containerStyle['paddingRight'] = theme.spacing(2)
  }

  let contentStyle = {}
  if (content_width && content_width > 0) {
    if (smUp)      
      contentStyle['width'] = `${content_width}%`
    else      
      contentStyle['width'] = '100%'
      // contentStyle['width'] = `${Math.max(Math.min(content_width * 1.5, 100), 60)}%`
  }
  else
    contentStyle['width'] = '100%'

  let backgroundStyle = {}
  let backgroundImageUrl = null
  if (background_images && background_images !== undefined && background_images.length > 0) {
    backgroundImageUrl = background_images[0].image_url
    if (backgroundImageUrl.startsWith("/"))
      backgroundImageUrl = "http://178.128.86.10:8000" + backgroundImageUrl
    backgroundStyle['backgroundImage'] = `url(${backgroundImageUrl})`
  }  

  backgroundStyle['color'] = color || 'white'
  backgroundStyle['marginHeight'] = (50 * section_height/100) || (50 * (66/100))
  backgroundStyle['sectionHeight'] = section_height || 66
  backgroundStyle['contentWidth'] = content_width || '100%'
  backgroundStyle['verticalAlignment'] = vertical_alignment || 'center'
  backgroundStyle['horizontalAlignment'] = horizontal_alignment || 'center'
  backgroundStyle['sectionWidth'] = section_width || 'full_bleed'
  backgroundStyle['overlayOpacity'] = overlay_opacity || 20
  
  let mdUp = useMediaQuery(theme.breakpoints.up('md'))  
  
  return (
    <Layout id={ 'section-' + (sectionIndex + 1) } backgroundClassName={classes.background} dark={color=='dark'} fullHeight={ sectionIndex == 0 ? true : false } backgroundStyle={backgroundStyle}>
      { backgroundImageUrl &&
        /* Increase the network loading priority of the background image. */
        <img style={{ display: 'none' }} src={backgroundImageUrl} alt="" />
      }
      { sectionIndex == 0 &&
        <Box mt={4} />
      }
      {/* <Fade> */}
      <div style={containerStyle}>
        <div style={contentStyle}>
          <TitleContentBlock { ...contentData } openLink={openLink}>
            { children &&
              <Box mt={2} mb={2}>
              { Array.isArray(children) ?
                <>
                { children.map(c => (c)) }
                </>
                :
                <>
                { children }
                </>
              }
              </Box>
            }            
          </TitleContentBlock>
        </div>
      </div>
      {/* </Fade> */}
    </Layout>
  );
}

Section.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(Section)
